module.exports = __webpack_public_path__ + "img/x10.263d2d6c.jpg";